import { createReducer } from "typesafe-actions";
import { WorkstationActionTypes, WorkstationState } from "./types";
import { fetchRequest, fetchSuccess, fetchError } from "./actions";

export const initialState: WorkstationState = {
  data: undefined,
  errors: undefined,
  loading: false,
};

type ActionType =
  | ReturnType<typeof fetchRequest>
  | ReturnType<typeof fetchSuccess>
  | ReturnType<typeof fetchError>;

export default createReducer<WorkstationState, ActionType>(initialState)
  .handleType(WorkstationActionTypes.FETCH, (state) => {
    return { ...state, loading: true };
  })
  .handleType(WorkstationActionTypes.FETCH_SUCCESS, (state, action) => {
    return {
      ...state,
      loading: false,
      data: action.payload,
      errors: undefined,
    };
  })
  .handleType(WorkstationActionTypes.FETCH_ERROR, (state, action) => {
    return {
      ...state,
      loading: false,
      errors: action.payload,
    };
  });
